import React from 'react';
import { useAuth } from 'wasp/client/auth';
import { routes } from 'wasp/client/router';
import { LinkButton } from '../../components/ui';

export function NotFoundPage() {
  const { data: user } = useAuth();

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-6xl font-bold  mb-4">404</h1>
        <p className="text-lg text-bodydark mb-8">
          Oops! The page you're looking for doesn't exist.
        </p>
        <LinkButton
          to={user ? routes.ArticlesRoute.to : routes.LandingPageRoute.to}
          className="inline-block px-8 py-3 text-white font-semibold bg-primary-600 rounded-lg hover:bg-primary-700 transition duration-300"
        >
          Go Back Home
        </LinkButton>
      </div>
    </div>
  );
}
